import React from 'react'
import PropTypes from 'prop-types'
import { Input, Select, MediaQuery, Level, Box } from '@deseretbook/react-ui'
import { Analytics } from '../../../dbcom'

/**
 * Filters reviews by search term/stars and passes them to the ReviewsList component
 * @param {func} setFilters - function that sets the filter object
 * @param {obj} filters - the current filter settings.
 * @returns {func} Component
 */
export const ReviewsFilter = ({ setFilters, filters }) => {
  const { keywords, rating } = filters

  /**
   * Updates Filter array by text
   * @param {object} keywordInput - The input for keyword filters
   * the filters state.
   */
  const handleInputChange = (keywordInput) => {
    const { value } = keywordInput

    setFilters({ ...filters, keywords: value })
  }

  /**
 * Updates Filter array by rating
 * @param {object} ratingInput - The input for rating filters.
 * Should be a select element.
 */
  const handleRatingChange = (ratingInput) => {
    const { value } = ratingInput

    setFilters({ ...filters, rating: Number(value) })
  }

  /**
   * Adds tracking events when the keyword/rating inputs are used.
   * @param {obj} e - The event object
   */
  const trackFilterEvent = (e) => {
    const { value, name } = e.target

    e.preventDefault()

    if (value && value !== '10') {
      Analytics.track({
        category: 'Reviews',
        action: `Filter by ${name} input`,
        label: `Filter reviews by ${name}, ${value}`,
        value: filters,
      }, { isInteractive: true })
    }
  }

  // The Select component for selecting a rating filter
  const ratingDropdown = (
    <Select
      name="rating"
      label="Filter by Rating"
      aria-label="Filter reviews by rating."
      onChange={({ target }) => handleRatingChange(target)}
      onBlur={trackFilterEvent}
      value={rating}
      required
      removeHint
      options={[
        { value: '10', label: 'Show all ratings' },
        { value: '5', label: '5 Stars' },
        { value: '4', label: '4 Stars' },
        { value: '3', label: '3 Stars' },
        { value: '2', label: '2 Stars' },
        { value: '1', label: '1 Star' },
      ]}
    />)

  const keywordInput = (
    <Input
      name="keyword"
      type="text"
      label="Filter by Keyword"
      value={keywords}
      removeHint
      inputWrapperProps={{
        onBlur: trackFilterEvent,
      }}
      onChange={({ target }) => handleInputChange(target)}
    />
  )

  return (
    <MediaQuery.Medium>
      {isMediumOrLarger => (
          isMediumOrLarger
          ? (
            <Level>
              <Level.Left>
                <Level.Item>
                  { keywordInput }
                </Level.Item>
                <Level.Item>
                  <Box width={14}>
                    { ratingDropdown }
                  </Box>
                </Level.Item>
              </Level.Left>
            </Level>
            )
          : (
            <React.Fragment>
              { keywordInput }
              { ratingDropdown }
            </React.Fragment>
          )
      )}
    </MediaQuery.Medium>
  )
}

ReviewsFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    keywords: PropTypes.string,
    rating: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
  }),
}
